import { Modal, Select } from "antd";
import { ListFilter } from "lucide-react";
import React, { useEffect, useState } from "react";
import { getAssignedGuideBatchData } from "../../../../../../api/org-admin";
import Utils from "../../../../../../utils/Utils";
import WebUtils from "../../../../../../utils/WebUtils";

function FilterModal({
  filterModalFlag,
  setFilterModalFlag,
  jobGuideIdentifier,
  setLoading,
  setBatchIdsFilter,
  batchIdsFilter,
}) {
  const userDetail = Utils.getUserDetail();
  const [tempFilter, setTempFilter] = useState({
    // interviewState: interviewState,
    batch: batchIdsFilter || [],
  });

  const [batchIdData, setBatchIdData] = useState(null);

  const getBatch = () => {
    const url = `${getAssignedGuideBatchData}?organizationId=${
      userDetail?.organizationId || null
    }&jobGuideIdentifier=${jobGuideIdentifier}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          // console.log(result.data);
          let data = result?.data?.data;
          setBatchIdData(data);
          //   setBatchIdData(result.data)
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const batchOptions = Array.from(
    new Map([
      ...(batchIdData || []).map((item) => [
        item.batchIdentifier,
        {
          label: (
            <div>
              <p className="font-medium mb-0">
                {item.batchName}{" "}
                <span className="text-[.75rem] text-gray-500">
                  ({item.batchIdentifier})
                </span>
              </p>

              <p className="text-[.75rem] text-gray-500 mb-0">
                Created on{" "}
                {new Date(item.assignedDate).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </div>
          ),

          value: item.batchIdentifier,
          title: item.batchName,
        },
      ]),
    ]).values(),
  );

  const handleSubmit = () => {
    // setInterviewState(tempFilter.interviewState);
    setBatchIdsFilter(tempFilter.batch);
    setFilterModalFlag(false);
  };

  useEffect(() => {
    getBatch();
  }, []);
  return (
    <Modal
      open={filterModalFlag}
      onCancel={() => setFilterModalFlag(false)}
      centered
      footer={null}
      title={
        <div className="flex items-center gap-2">
          <span>
            <ListFilter size={16} />
          </span>
          <p>Filter</p>
        </div>
      }
    >
      <div className="mt-5">
        <p>Select batch IDs</p>
        <Select
          mode="multiple"
          allowClear
          className="w-full mt-1"
          size="large"
          placeholder="Select batch IDs"
          value={tempFilter.batch}
          onChange={(value) => {
            // console.log(value);
            setTempFilter((prev) => ({
              ...prev,
              batch: value,
            }));
          }}
          options={batchOptions}
          maxTagCount="responsive"
          optionLabelProp="title"
        />
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setFilterModalFlag(false)}
        >
          Cancel
        </button>

        <button
          //   disabled={selectedBatchGuides?.length < 1}
          onClick={handleSubmit}
          className={` btn-orange px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Apply filter
        </button>
      </div>
    </Modal>
  );
}

export default FilterModal;
